/**
 * Página de Teste Spotify
 * Apenas para desenvolvimento
 */

import { SpotifyDebugPanel } from '@/components/debug/SpotifyDebugPanel';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function SpotifyTest() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-background p-4 md:p-8">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-2">
          <h1 className="text-3xl font-bold">Spotify Integration Test</h1>
          <p className="text-muted-foreground">
            Página de desenvolvimento para testar a integração com Spotify
          </p>
        </div>
        
        {/* Botão para diagnóstico */}
        <div className="flex justify-center">
          <Button 
            onClick={() => navigate('/spotify-setup')}
            variant="default"
            size="lg"
            className="gap-2"
          >
            🔧 Diagnóstico e Configuração
          </Button>
        </div>
        
        <SpotifyDebugPanel />

        <div className="bg-card border rounded-lg p-6 space-y-4">
          <h2 className="text-xl font-semibold">🚀 Como Configurar</h2>
          
          <ol className="list-decimal list-inside space-y-3 text-sm">
            <li>
              <strong>Criar App no Spotify:</strong>
              <ul className="list-disc list-inside ml-6 mt-1 text-muted-foreground">
                <li>Acesse <a href="https://developer.spotify.com/dashboard" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Spotify for Developers</a></li>
                <li>Crie um novo app</li>
                <li>Adicione o Redirect URI: <code className="text-xs bg-muted px-1 py-0.5 rounded">
                  {window.location.origin}/oauth/spotify/callback
                </code></li>
                <li>Copie o <strong>Client ID</strong></li>
              </ul>
            </li>
            
            <li>
              <strong>Configurar Secret:</strong>
              <p className="ml-6 mt-1 text-muted-foreground">
                No chat do Lovable, peça para atualizar o secret <code className="text-xs bg-muted px-1 py-0.5 rounded">SPOTIFY_CLIENT_ID</code> com seu Client ID
              </p>
            </li>
            
            <li>
              <strong>Testar Conexão:</strong>
              <p className="ml-6 mt-1 text-muted-foreground">
                Clique em "Conectar Spotify" no painel acima e autorize o app
              </p>
            </li>
            
            <li>
              <strong>Testar Reprodução:</strong>
              <p className="ml-6 mt-1 text-muted-foreground">
                Após conectar, clique em "Tocar Teste" para verificar se o player funciona
              </p>
            </li>
          </ol>
        </div>

        <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-amber-600 dark:text-amber-400 mb-2">
            ⚠️ Requisitos Importantes
          </h3>
          <ul className="list-disc list-inside space-y-1 text-sm text-amber-700 dark:text-amber-300">
            <li>É necessário uma conta <strong>Spotify Premium</strong></li>
            <li>O Web Playback SDK não funciona com contas gratuitas</li>
            <li>O redirect URI deve ser exatamente igual ao configurado</li>
            <li>Teste primeiro no ambiente de desenvolvimento</li>
          </ul>
        </div>

        <div className="bg-card border rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-3">🎵 Como Funciona Durante a Corrida</h3>
          <div className="space-y-2 text-sm text-muted-foreground">
            <p>
              1. O sistema analisa seu BPM atual e contexto (hora do dia, clima, mood)
            </p>
            <p>
              2. Busca músicas reais no Spotify que combinam com o momento
            </p>
            <p>
              3. Inicia reprodução automaticamente usando o Web Playback SDK
            </p>
            <p>
              4. Ajusta a playlist dinamicamente conforme seu ritmo muda
            </p>
            <p>
              5. Você tem controle total: pausar, pular, ajustar volume
            </p>
          </div>
        </div>

        <div className="text-center text-sm text-muted-foreground">
          <p>
            💡 <strong>Dica:</strong> Esta página é apenas para desenvolvimento. 
            Remove ela antes de ir para produção.
          </p>
        </div>
      </div>
    </div>
  );
}
